import { Card } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export function OnboardingSetupCardSkeleton() {
  return (
    <Card aria-busy="true" aria-label="Loading setup" className="shadow-sm">
      <div className="flex flex-col gap-5 p-[var(--sp-card)]">
        <Skeleton className="h-4 w-48" />
        <div className="space-y-2">
          <Skeleton className="h-8 w-56" />
          <Skeleton className="h-4 w-full max-w-md" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-2 w-full rounded-full" />
          <div className="flex items-center justify-between">
            <Skeleton className="h-3 w-40" />
            <Skeleton className="h-3 w-8" />
          </div>
        </div>
        <Skeleton className="h-9 w-32 rounded-md" />
      </div>
    </Card>
  )
}
